// Save-as name and link for the image preview's Download button.

const IMAGE_EXT_RE = /\.(png|jpe?g|gif|webp|heic|heif|avif)$/i;
const MIME_EXT: Record<string, string> = {
  "image/png": "png", "image/jpeg": "jpg", "image/webp": "webp", "image/gif": "gif",
  "image/heic": "heic", "image/heif": "heif", "image/avif": "avif",
};
// Characters a file system or shell rejects or misreads in a name, plus controls.
// eslint-disable-next-line no-control-regex -- matching control characters is the point
const UNSAFE_RE = /[\u0000-\u001f\u007f<>:"/\\|?*]+/g;

/**
 * A safe file name to save an image as: the last segment of `filename`
 * without characters Windows or macOS refuse, at most 100 characters before
 * the extension, "image" when nothing usable is left, and an extension taken
 * from `mimeType` (PNG when unknown) when the name has none.
 */
export function imageDownloadName(filename?: string, mimeType?: string): string {
  const last = (filename ?? "").split(/[\\/]/).pop() ?? "";
  const name = last.replace(UNSAFE_RE, " ").replace(/\s+/g, " ").trim().replace(/^\.+/, "");
  const ext = IMAGE_EXT_RE.exec(name)?.[0] ?? "";
  const stem = Array.from(ext ? name.slice(0, -ext.length) : name).slice(0, 100).join("")
    .replace(/[. ]+$/, "") || "image";
  const type = (mimeType ?? "").split(";")[0]!.trim().toLowerCase();
  return stem + (ext || "." + (MIME_EXT[type] ?? "png"));
}

/**
 * The href a download link may use for this image source: an object URL
 * (saved from memory, no new request) or a same-origin address. Null for
 * anything else, where the browser would ignore `download` and navigate away.
 */
export function downloadableHref(src: string, pageUrl: string): string | null {
  try {
    const url = new URL(src, pageUrl);
    if (url.protocol === "blob:") return src;
    if ((url.protocol === "https:" || url.protocol === "http:") && url.origin === new URL(pageUrl).origin) return url.href;
  } catch {
    // Not a URL: nothing to download.
  }
  return null;
}
